<template>
  <div class="home">
    <!-- 视频 -->
    <!-- <div :style="{ height: documenHeight }" class="topVideo"> -->
    <!--    <div class="topVideo">
          <img src="../assets/3D/homeBanner.png" alt="" />
          <div class="topVideo_box">
            <p>
              专注3D打印技术<br />
              在不同行业的应用<br />
              以技术赋能行业促进产业升级
            </p>
            <button>了解更多</button>
          </div>
        </div>-->
    <div class="soluBanner">
      <el-carousel
        indicator-position="none"
        :interval="5000"
        :height="imgHeight + 'px'"
      >
        <el-carousel-item v-for="(item, index) in imgurl" :key="index">
          <a :href="linkUrl[index]" target="_blank">
            <img :src="item" alt="" style="width: 100%" ref="image" />
            <!-- @click="getBannerlist(linkUrl[index])" -->

            <!-- <img src="../assets/bannerHome1.png" alt="" style="width: 100%"  ref="image"/> -->
          </a>
          <div class="soluBanBox">
            <!--            <h2>首页</h2>
                        <div class="soluBanText">
                          <p>
                            专注3D打印技术<br />
                            在不同行业的应用<br />
                            以技术赋能行业促进产业升级
                          </p>
                        </div>-->
            <!--<button @click="getCallOur">联系我们</button>-->
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
    <!-- 新闻中心 -->
    <div class="new_center">
      <div class="allTitle">
        <p>3D打印行业资讯</p>
        <span>精选重点新闻，分享价值讯息</span>
        <div class="flex newBorderBox">
          <i> </i>
        </div>
      </div>
      <div class="new_center_more" @click="getNewsMore">查看更多 > </div>
      <div class="new_center_top flex">
        <div
          class="new_center_top_left"
          v-show="newCenterShow"
          @click="getNewsItemDetail(newItem.uuid)"
        >
          <div class="new_left_img">
            <img :src="newItem.img" alt="" />
          </div>
          <div class="new_left_mess">
            <p class="new_left_title">
              <!--              核心产品首发，联合国家级双跨平台开启领航者计划核心产品首发，联合国家级双跨平台开启领航者计划-->
              {{ newItem.title }}
            </p>
            <span class="new_left_time">{{ newItem.time | formatDate }}</span>
          </div>
        </div>
        <div class="new_center_top_right" v-show="newCenterShow">
          <div
            class="new_right_box flex"
            v-for="(new_itmes, index) in newTopList"
            :key="index"
            @click="getNewsItemDetail(new_itmes.uuid)"
          >
            <div class="new_right_img">
              <img :src="new_itmes.img" alt="" />
            </div>
            <div class="new_right_content">
              <h4 class="new_right_title">
                {{ new_itmes.title }}
              </h4>
              <span class="new_right_time">{{
                new_itmes.time | formatDate
              }}</span>
              <p class="new_right_text">
                {{ new_itmes.message }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="new_center_bottom flex" v-show="newCenterShow2">
        <div
          class="new_bottom"
          v-for="(items, index) in newCenter"
          :key="index"
          @click="getNewsItemDetail(items.uuid)"
        >
          <p class="">{{ items.message }}</p>
          <span class="gray">{{ items.time | formatDate }}</span>
        </div>
        <div class="new_bottom_empty"></div>
        <div class="new_bottom_empty"></div>
        <div class="new_bottom_empty"></div>
        <div class="new_bottom_empty"></div>
      </div>
    </div>
    <!-- 平台是核心 -->
    <div class="content">
      <!-- <div class="content_top1" v-show="conShow"> -->
      <div class="content_top1"  v-show="conShow">
        <HomeSwiper />
      </div>
    </div>
    <!-- 主要业务 -->
    <div class="main">
      <div class="allTitle">
        <p>主要业务</p>
        <span
          >构建3D打印产业一流的工业互联网平台，为3D打印产业赋能，促进产业发展</span
        >
        <div class="flex newBorderBox">
          <i> </i>
        </div>
      </div>

      <div class="main_tabs flex">
        <p
          :class="mainTabsIn == index ? 'main_active' : ''"
          v-for="(mainItems, index) in mainTabs"
          :key="index"
          @click="getMainTabs(index)"
        >
          {{ mainItems.name }}
        </p>
      </div>
      <!-- v-show="mainShow && mainTabsIn == index" -->

      <div
        class="main_mess flex"
        v-show="mainShow && mainTabsIn == index"
        v-for="(mainItems, index) in mainTabs"
        :key="index"
      >
        <div class="main_mess_img">
          <img :src="mainItems.value" alt="" />
          <!-- <el-image :src="mainItems.value" fit="fit"> </el-image> -->
        </div>
        <div class="main_mess_content">
          <div class="main_mess_content2">
            <img src="../assets/3D/businessHome2.png" alt="" />
            <!--            <img :src=mainMess.value alt="" />-->
          </div>
          <div class="main_mess_box">
            <p class="main_con_title">{{ mainItems.name }}</p>
            <p class="main_con_text">
              {{ mainItems.remarks }}
            </p>
            <a class="a-style" @click="linkDownload(mainItems.linkUrl)"
              ><span class="main_con_more">了解更多 ></span></a
            >
            >
          </div>
        </div>
      </div>

      <!-- 地图 -->
      <div class="mapPosition" @click="mapDivClick">
        <div class="mapInput flex">
          <el-input
            placeholder="寻找附近的服务商"
            v-model="inputMapParam"
            clearable
            @clear="getClearMap"
          >
          </el-input>
          <!-- <input type="text" placeholder="搜园区" v-model="inputMapParam" /> -->

          <i class="iconfont" @click="getParkAddrByName()">&#xe6a8;</i>
        </div>

        <!-- <div

          <i class="iconfont" @click="getProviderSettledInfo()">&#xe6a8;</i>
      </div>
       <div

          class="flex map"
          :style="{ top: mapPopX, left: mapPopY }"
          v-show="mapShow"
        >
          <div class="mapImg">
            <el-image :src="mapParkDetail.imageURL" fit="none"></el-image>
          </div>
          <div class="mapMess">
            <p class="mapMessT">{{ mapParkDetail.parkName }}</p>
            <div class="flex mapMessBox">
                          <p class="mapMessP">材料</p>
                          <i></i>
                          <p> 服务</p>
                          <i></i>
                          <p> 商品</p>
                          <i></i>
                          <p>订单</p>
            </div>
            <div>
              简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介
            </div>
            <div class="mapMessBut">
              <button>关注TA</button>
              <button
                style="cursor: pointer"
                @click.stop="goToDetail(mapParkDetail.uuid)"
              >
                查看详情
              </button>
              <button
                style="cursor: pointer"
                @click.stop="goToDetail(mapParkDetail.uuid)"
              >
                进入主页
              </button>
            </div>
          </div>
        </div>  -->
         <!-- 弹窗 -->
         <div
                class="flex maps"
                :style="{ top: mapPopX, left: mapPopY }"
                v-show="mapShow"
            >
                <div class="mapImg">
                    <img v-if="mapParkDetail.imageURL" :src="mapParkDetail.imageURL"></img>
                    <img v-else src="@/assets/image/服务商_画板 1.jpg"></img>
                    <!-- <img v-else src="../../assets/设计市场/头像1.jpeg" alt=""> -->
                    <div class="mapImgIcon">
                      <i class="el-icon-location"></i>
                      <p>{{ mapParkDetail.province }}.{{ mapParkDetail.city }}</p>
                    </div>
                </div>
                <div class="mapMess">
                    <p class="mapMessT" @click.stop="goToDetail(mapParkDetail.uuid)">{{  mapParkDetail.parkName  }}</p>
                    <div class="flex mapMessWork">
                      <div class="flex text">
                        <p>材料</p>
                        <span>{{ mapParkDetail.materialCount }}</span>
                      </div>
                      <!-- <i class="gangMess"></i> -->
                      <div class="flex text">
                        <p>服务</p>
                        <span>{{ mapParkDetail.serviceCount }}</span>
                      </div>
                      <!-- <i class="gangMess"></i> -->
                      <div class="flex text">
                        <p>商品</p>
                        <span>{{ mapParkDetail.goodsCount }}</span>
                      </div>
                       <!-- <i class="gangMess"></i> -->
                      <div class="flex text">
                        <p>订单</p>
                        <span>{{ mapParkDetail.orderCount }}</span>
                      </div>
                    </div>
                    <div class="mapMessText">{{ mapParkDetail.content }}</div>
                    <!--<div class="mapMessBut">
                        <button v-if="!mapParkDetail.follow" @click="saveFollow(mapParkDetail)">
                            关注TA
                        </button>
                        <button v-else @click="removeFollow(mapParkDetail)">
                            取消关注
                        </button>
                        <button @click.stop="goToDetail(mapParkDetail.uuid)">
                            查看详情
                        </button>
                    </div>-->
                </div>
            </div>
        <div ref="ChinaMap" :style="{ width: '100%', height: '600px' }"></div>
      </div>
    </div>
    <!-- 解决方案 -->
    <div class="solution">
      <div class="allTitle">
        <p>解决方案</p>
        <span>面向丰富的业务场景，提供整套行业和技术解决方案</span>
        <div class="flex newBorderBox">
          <i> </i>
        </div>
      </div>
      <div class="solution_box" v-show="soluShow" ref="solutions">
        <div class="solution_boxmess flex">
          <div
            class="solution_box_mess flex"
            v-for="(soluItems, index) in solutionList"
            :key="index"
            @click="getSolutionDetail(soluItems.uuid)"
            @mouseover="setBackground(soluItems.backImagePath, $event)"
            @mouseleave="setBackground(solutionImgs, $event)"
          >
            <!-- @mouseover="setBackground(soluItems.backImagePath, $event)"
                        @mouseleave="setBackground(undefined, $event)" -->

            <!-- <div class="solution_box_img"></div> -->
            <div class="solution_box_text">
              <h5>{{ soluItems.programName }}</h5>
              <h4>{{ soluItems.name }}</h4>
              <p class="gray">
                {{ soluItems.description }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 园区生态 -->
    <div class="park">
      <div class="allTitle">
        <p>园区生态</p>
        <span>打造增材制造园区生态体系，助力园区示范推广</span>
        <div class="flex newBorderBox">
          <i> </i>
        </div>
      </div>
      <div
        class="park_box"
        v-for="(imgItems, index) in parkInformationList"
        :key="index"
        v-show="parkIndex == index"
      >
        <div class="park_box_img">
          <img v-if="parkMess" :src="imgItems.thumbnail" alt="" />
        </div>
        <div class="park_background">
          <div class="park_box_mess" v-show="parkShow">
            <p class="park_box_messtitle">{{ imgItems.parkName }}</p>
            <p
              class="park_box_messtext"
              @mouseenter="getMessagesAll"
              @mouseleave="getMessagesAllNo"
            >
              {{ imgItems.detail }}
            </p>
            <button @click="goToParkDetail(imgItems.uuid)">了解更多</button>
            <button @click="goToParkVr(imgItems)"  v-if="imgItems.vrUrl || (imgItems.vrList && imgItems.vrList.length > 0)">园区VR</button>
          </div>
          <div class="park_imglist flex" v-show="parkShows">
            <div
              class="park_img"
              :class="indexs == parkIndex ? 'park_active' : 'park_img'"
              v-for="(imgItemss, indexs) in parkInformationList"
              :key="indexs"
              @click="getParkImg(indexs)"
            >
              <img :src="imgItemss.thumbnail" alt="" />
              <div class="parkFuimg"></div>
            </div>
            <!-- <div class="park_img2"></div> -->
          </div>
        </div>
        <!-- 展示的全部内容 -->
        <!-- <div class="messageAll" v-if="messageAll">
                  {{ parkMess.messages }}
                </div> -->
      </div>
      <div class="park_bottom">
        <div class="park_bottom_content">
          <div class="park_bottom_title">
            <p>重点企业</p>
            <i></i>
          </div>
          <div class="flex pack_flex" v-show="packFlexShow">
            <div
              class="park_bottom_list"
              v-for="(items, index) in parkList"
              :key="index"
            >
              <div class="park_bottom_img">
                <img :src="items.thumbnail" alt="" />
              </div>
              <div class="park_bottom_text">
                <div>{{ items.enterpriseName }}</div>
                <p
                  class="gray"
                  @mouseenter="getEnterpriseAll(items, index)"
                  @mouseleave="getEnterpriseNo(items)"
                >
                  {{ items.details }}
                </p>
              </div>
              <!-- <div
                              class="enterpriseAll"
                              v-if="items.isShowPop"
                              @mouseenter="getEnterpriseAll(items, index)"
                              @mouseleave="getEnterpriseNo(items)"
                            >
                              {{ items.details }}
                            </div> -->
            </div>
            <div class="park_bottom_list2"></div>
            <div class="park_bottom_list2"></div>
            <div class="park_bottom_list2"></div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import HomeSwiper from "./parkSwiper/homeSwiper";
import axios from "axios";
import { mapState,mapMutations } from "vuex";

import {
  getIndexParkList,
  getIndexNewTextList,
  getParkEnterpriseList,
  getParkAddrList,
  getBannerList,
  getPrintEnterPriseList,
  isFollow,
  removeFollow,
  saveFollow,
  findShopSettledInfo,
  getNewcurrent,
  getParkDetailData,
  getIndexSolutionData,
  getNewProgramDetail,
} from "../utils/interface";
import api from "../utils/api";
import Vue from "vue";

export default {
  name: "HelloWorld",
  metaInfo: {
    title: '3D打印行业工业互联网平台——增材云| 3D打印线上交易平台', // set a title
    meta: [{                 // set meta
      name: 'keywords',
      content: '3D打印平台|增材制造平台|3D模型下载设计接单|3D打印企业数字化管理工具|3D打印服务|3D打印厂商|3D打印原材料\n'
    },{                 // set meta
      name: 'description',
      content: '增材云平台是安徽省重点工业互联网平台，聚合3D打印设计师、3D打印模型、3D打印厂商、3D打印原料、3D打印软件及课程等6大资源，让用户享一站式个性化3D打印定制服务。旗下智能工厂和3D打印机远程运维方案，帮助3D打印厂商实现企业数字化、智能化管理。\n'
    }],
  },
  components: {
    HomeSwiper,
  },
  data() {
    return {
      solutionImgs: require("../assets/solutionHome.png"),
      //轮播图
      bannerList: [],
      imgurl: [],
      documenHeight: "",
      mapShow: false,
      // 新闻中心下面的列表信息
      newCenterShow: false,
      newCenterShow2: false,
      newCenter: [],
      newTopList: [],
      newItem: {
        title: "",
        messages: "",
        time: "",
        img: "",
      },
      newList: [
        {
          title: "",
          children: [
            {
              title: "",
            },
          ],
        },
      ],
      // 园区生态
      parkShow: false,
      parkShows: false,
      packFlexShow: false,
      parkIndex: "3",
      parkInformationList: [],
      parkImg: [],
      parkMess: {
        uuid: "",
        title: "",
        messages: "",
      },
      parkList: "",
      messageAll: false,
      enterpriseAll: false,
      enterpriseAllIndex: "0",
      // 解决方案
      soluShow: false,
      mapdata: [],
      solutionList: [],

      indexBanner: {
        imgUrl: "",
        url: "",
        name: "",
        uuid: "",
      },
      // 主要业务
      mainShow: false,
      mainTabs: [],
      mainTabsIn: "0",
      mainMess: {
        title: "",
        messages: "",
        value: "",
      },

      // 平台是核心
      contentTbas: "2",
      conShow: false,
      contentList: [],
      contentMess: {
        title: "平台是核心",
        messages:
          "平台是企业数字化转型的核心，是连接用户与设备、数据收集、分析、建模的载体，承载了构建丰富多彩的工业互联网应用生态的使命，是实现万物互联的核心",
      },
      contentIcon: [
        {
          icon: "icon",
        },
        {
          icon: "icon",
        },
        {
          icon: "icon",
        },
        {
          icon: "icon",
        },
        {
          icon: "icon",
        },
      ],
      // 地图
      ifbox: false,
      TipsList: [],
      inputMapParam: "",
      mapPopX: "0px",
      mapPopY: "0px",
      //地图对象数据
      mapParkDetail: {
        parkName: "",
        order: "",
        uuid: "",
        imageURL: "",
        capacity: "",
        peoNum: "",
        outPutValue: "",
      },
      setIn: null, // 定时器
      imgHeightsetIn: null,
      imgHeight: "",
      linkUrl: [],
      loading: true,
      // 服务商信息
      settledInfo:[],
      userMessages:{},
    };
  },
  created() {
    this.setIn = setInterval(() => {
      if (this.isTokenDoor === true) {
        clearInterval(this.setIn);
        this.getIndexBanner();
        this.getIndexVocationalWork();
        // this.getMapData();
        this.getsolutionList();
        this.getParkInformationList();
        this.getIndexNewTextList();
        this.getBodyHeight();
        this.getProviderSettledInfo();
        //this.getParkEnterpriseList();
        // 获取用户信息
        getNewcurrent().then((res) => {
          this.userMessages = res;
        })
        .catch((err) => {
          console.log(err);
        });
      }
    }, 500);
  },
  mounted() {
    window.addEventListener("scroll", this.menu);
    // this.initEcharts();
    window.addEventListener("resize", () => {
      if (this.$refs.image[0]) {
        this.imgHeight = this.$refs.image[0].height;
      }
    });
  },
  computed: {
    ...mapState({
      isTokenDoor: "isTokenDoor",
      isLogin: "isLogin",
      isUsermessage:"isUsermessage"
    }),
  },
  filters: {
    formatDate: function (value) {
      let date = new Date(value);
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM;
      let d = date.getDate();
      d = d < 10 ? "0" + d : d;
      let h = date.getHours();
      h = h < 10 ? "0" + h : h;

      return y + "-" + MM + "-" + d;
    },
  },
  methods: {
    ...mapMutations(["isLoginVuex"]),
    imgLoad() {
      this.$nextTick(function () {
        // 获取窗口宽度*图片的比例，定义页面初始的轮播图高度
        // this.imgHeight = (document.body.clientWidth * 1) / 4;
        this.imgHeightsetIn = setInterval(() => {
          if (this.imgHeight == 0) {
            if (this.$refs.image[0]) {
              this.imgHeight = this.$refs.image[0].height;
            }
          } else {
            clearInterval(this.imgHeightsetIn);
            // console.log(6666, this.imgHeight);
          }
        }, 520);
      });
    },
    goToParkDetail(uuid) {
      //this.$router.push({ name: "allPark", params: { uuid: uuid } });
      let routeData = this.$router.resolve({
        name: "allPark",
        params: { uuid: uuid },
      });
      window.open(routeData.href, "_blank");
    },
    goToParkVr(items){
      if(items.vrUrl){
        let routeData = this.$router.resolve({
          name: "VeiwsUrl",
          query: {
            url: items.vrUrl
          }
        });
        window.open(routeData.href, "_blank");
      } else if(items.vrList.length > 0){
        let routeData = this.$router.resolve({
          name: "veiws",
          params: { uuid: items.uuid },
        });
        window.open(routeData.href, "_blank");
      }

    },
    linkDownload(url) {
      window.open(url, "_blank"); // 新窗口打开外链接
    },
    //获取banner图
    getIndexBanner() {
      getBannerList({
        groupCode: "PORTAL_BANNER",
      })
        .then((response) => {
          if (response.length !== 0) {
            for (let i = 0; i < response.length; i++) {
              let imgUrl = response[i].value;
              let linkUrl = response[i].linkUrl;
              this.imgurl.push(imgUrl);
              this.linkUrl.push(linkUrl);
            }
            // console.log("我是linkUrl", this.linkUrl);

            // this.bannerList = response;
            this.imgLoad();
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    // getBannerlist(url){
    //   console.log(url)
    // },
    // 主要业务
    getIndexVocationalWork() {
      getBannerList({
        groupCode: "MAIN_SERVICE",
      })
        .then((res) => {
          this.mainTabs = res;
          /*this.mainMess.title = res[this.mainTabsIn].name;
                        this.mainMess.messages = res[this.mainTabsIn].remarks;
                        this.mainMess.value = res[this.mainTabsIn].value;*/
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    // 主要业务tabs点击切换
    getMainTabs(i) {
      this.mainTabsIn = i;
      /*this.mainMess.title = this.mainTabs[i].name;
                this.mainMess.messages = this.mainTabs[i].remarks;
                this.mainMess.value = this.mainTabs[i].value;*/
    },

    getMainTabDetail() {
      console.log(this.mainTabs[this.mainTabsIn]);
      let routeData = this.$router.resolve({
        name: this.mainTabs[this.mainTabsIn].linkUrl,
      });
      window.open(routeData.href, "_blank");
    },

   async getParkAddrByName() {
   //    getParkAddrList({ param: this.inputMapParam })
   //      .then((response) => {
			// console.log(response)
   //        this.mapdata = response;
		 //  console.log(this.settledInfo,222)

   //        this.initEcharts();
   //      })
   //      .catch(function (error) {
   //        console.log(error);
   //      });
   await getPrintEnterPriseList({ name: this.inputMapParam }).then((res)=>{
	   // console.log(res)
	   this.settledInfo= res;
   })
   .catch(function (error) {
          console.log(error);
        });
   this.getSettledInfo()
   this.initEcharts();
    },
    getClearMap() {
      //this.getParkAddrByName();
      this.getProviderSettledInfo();
    },
    getIndexNewTextList() {
      getIndexNewTextList({
        current: 1,
        pageSize: 11,
      })
        .then((response) => {
          let topList = new Array();
          let centerList = new Array();
          for (let i = 0; i < response.length; i++) {
            let obj = new Object();
            if (i == 0) {
              this.newItem.time = response[i].publishDate;
              this.newItem.uuid = response[i].uuid;
              this.newItem.img = response[i].pictureUrl;
              this.newItem.title = response[i].title;
              this.newItem.messages = response[i].summary;
              this.newItem.programUuid = response[i].programUuid;
            } else if (i <= 2) {
              obj["img"] = response[i].pictureUrl;
              obj["title"] = response[i].title;
              obj["uuid"] = response[i].uuid;
              obj["time"] = response[i].publishDate;
              obj["message"] = response[i].summary;
              obj["programUuid"] = response[i].programUuid;
               this.newTopList.push(obj);
            } else {
              obj["time"] = response[i].publishDate;
              obj["uuid"] = response[i].uuid;
              obj["message"] = response[i].title;
              obj["programUuid"] = response[i].programUuid;
              this.newCenter.push(obj);
            }
          }
        })
        .catch(function (error) {
          console.log(error);
        });
      /*axios.get('/resource-portal/api/v1/news/item/text/getIndexNewTextList', {
                  params: {
                    current: 1,
                    pageSize: 9
                  }
                })*/
    },
    // 解决方案
    getsolutionList() {
      getIndexSolutionData()
        .then((res) => {
          // console.log(111, res);
          this.solutionList = res;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    setBackground(url, e) {
      e.currentTarget.style.backgroundImage = "url(" + url + ")";
    },

    goToDetail(uuid) {
      //this.$router.push({ name: "allPark", params: { uuid: uuid } });
      /*let routeData = this.$router.resolve({
        name: "allPark",
        params: { uuid: uuid },
      });
      window.open(routeData.href, "_blank");*/
      let routeData = this.$router.resolve({
        name: "printServiceIndex",
        params: { enterPriseId: uuid },
      });
      window.open(routeData.href, "_blank");
    },
    saveFollow(item){
      // 如果为当前登录用户的服务则不允许收藏
      // 获取当前用户信息
      if(this.isLogin){
        if(item.userUuid==this.userMessages.uuid){
          this.$message.error('无法关注自己的店铺');
          return false;
        }
        // 收藏服务
        let params = {
          enterPriseUuid:item.uuid
        };
        saveFollow(params).then((res)=>{
          if(res.success){
            item.follow = !item.follow;
            this.$message.success('关注成功!');
            item.followUuid = res.data.uuid;
          }
        });
      }else{
        this.$message({
          type: "success",
          message: "您需要先登录哦！",
        });
        this.$router.push('/login')
      }
    },
    removeFollow(item){
      // 收藏服务
      let params = {
        uuid:item.followUuid,
      };
      removeFollow(params).then((res)=>{
        if(res.success){
          item.follow = !item.follow;
          this.$message.success('取消成功!');
          item.followUuid = "";
        }
      });
    },
    getSoluBox() {
      //this.$router.push("/solution");
      let routeData = this.$router.resolve({
        name: "/solution",
      });
      window.open(routeData.href, "_blank");
    },

    getNewsItemDetail(uuid) {
      let routeData = this.$router.resolve({
        name: "newDetails",
        params: { uuid: uuid },
      });
      window.open(routeData.href, "_blank");
    },

    /*    getNewsDetails() {
              this.$router.push("/newDetails");
            },
            getNewsDetails2() {
              this.$router.push("/newDetails");
            },
            getNewsDetails3() {
              this.$router.push("/newDetails");
            },*/

    mapDivClick(e) {
      // console.log(e.offsetX, e.offsetY);
      // this.mapPopY = e.offsetX + "px";
      // this.mapPopX = e.offsetY + "px";
      // 计算
      let comTop = 500 - 130;
      let comBottom = this.$refs.ChinaMap.offsetWidth - 610;
      // 计算高度是否超过盒子高度
      if (comTop < e.offsetY) {
        this.mapPopX = comTop + "px";
      } else {
        this.mapPopX = e.offsetY + "px";
      }
      // 计算宽度是否超过盒子宽度

      if (comBottom < e.offsetX) {
        this.mapPopY = comBottom + "px";
        // console.log(444, this.mapPopY);
      } else {
        this.mapPopY = e.offsetX + "px";
      }
    },
    // 页面分辨率高度
    getBodyHeight() {
      sessionStorage.setItem(
        "documenHeight",
        window.innerHeight + "px" ||
          document.documentElement.clientHeight + "px" ||
          document.body.clientHeight + "px"
      );
      sessionStorage.getItem("documenHeight");
      this.documenHeight = sessionStorage.getItem("documenHeight") || "";
    },
    // 页面滚动
    menu() {
      if (this.$isMobile()) {
        //这里是移动端
        this.conShow = true;
        this.mainShow = true;
        this.soluShow = true;
        this.parkShow = true;
        this.parkShows = true;
        this.packFlexShow = true;
        this.newCenterShow = true;
        this.newCenterShow2 = true;
      } else {
        //这里是pc端
        this.scroll =
          document.documentElement.scrollTop || document.body.scrollTop;
        // console.log(this.sroll);
        if (this.scroll > 200) {
          this.newCenterShow = true;
          this.newCenterShow2 = true;
        }
        if (this.scroll > 500) {
          this.conShow = true;
        }
        if (this.scroll > 1000) {
          this.mainShow = true;
        }
        if (this.scroll > 2300) {
          this.soluShow = true;
        }
        if (this.scroll > 2700) {
          this.parkShow = true;
        }
        if (this.scroll > 2900) {
          this.parkShows = true;
        }
        if (this.scroll > 3900) {
          this.packFlexShow = true;
        }
      }
    },
    circle_box_li_click(index) {
      let active = JSON.parse(JSON.stringify(this.core[index])); // 点击的
      // 当前中间的换到点击的位置展示
      this.$set(this.core, index, this.core[2]);
      // 点击的换到中间位置
      this.$set(this.core, 2, active);
    },

    getContentList(i) {
      this.contentTbas = i;
      this.contentMess.title = this.contentList[i].name;
      this.contentMess.messages = this.contentList[i].remarks;
    },

    getParkEnterpriseList(uuid) {
      getParkEnterpriseList({ current: 1, pageSize: 4, parkId: uuid })
        .then((response) => {
          response.forEach((item) => {
            item.isShowPop = false;
          });
          this.parkList = response;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    // 园区生态
    getParkInformationList: function () {
      getIndexParkList({
        current: 1,
        pageSize: 7,
      })
        .then((res) => {
          this.parkInformationList = res;
          this.getParkEnterpriseList(this.parkInformationList[3].uuid);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getParkImg(i) {
      this.parkIndex = i;
      this.getParkEnterpriseList(this.parkInformationList[i].uuid);
    },
    // 鼠标移入事件
    getMessagesAll() {
      this.messageAll = true;
    },
    // 鼠标移除事件
    getMessagesAllNo() {
      this.messageAll = false;
    },
    // 鼠标移入事件
    getEnterpriseAll(item, index) {
      // console.log("鼠标移入事件");
      item.isShowPop = true;
      // this.enterpriseAll = true;
      // this.enterpriseAllIndex = i;
    },
    // 鼠标移除事件
    getEnterpriseNo(item) {
      // console.log("鼠标移除事件");
      item.isShowPop = false;
    },

    //开发js   尤其要注意执行顺序和时间，异步和同步
    getMapData() {
      getParkAddrList()
        .then((response) => {
          this.mapdata = response;
          this.initEcharts();
        })
        .catch(function (error) {
          console.log(error);
        });

    },

    dealWithData() {
      let newStr = JSON.parse(JSON.stringify(this.mapdata));
	  // console.log(newStr)
      newStr.forEach((item) => {
        item.name1 = item.name;
        item.name = "";
      });
      let data = newStr;
      return data;
    },
    getSettledInfo(){
		// console.log(this.settledInfo)
      let dataInfo = [];
      this.settledInfo.forEach((item) => {
        let info = {};
        info.follow = item.follow;
        info.followUuid = item.followUuid;
        info.userUuid = item.userUuid;
        info.name1 = item.name;
        info.details = item.detailAddress;
        info.imageURL = item.storeHeader;
        info.content = item.content.replace(/<\s*\/?\s*[a-zA-z_]([^>]*?["][^"]*["])*[^>"]*>|&nbsp;|\s|[\r\n]*/g,'').replace('<br>','').replace('&gt;','>').replace('&lt;','<').replace('&amp;','&');
        info.name = "";
        info.uuid = item.enterPriseId;
        info.materialCount = item.materialCount;
        info.goodsCount = item.goodsCount;
        info.serviceCount = item.serviceCount;
        info.orderCount = item.orderCount;
        info.province = item.province;
        info.city = item.city;
        info.value = [Number(item.lng),Number(item.lat)];
        dataInfo.push(info);
      });
      let data = dataInfo;
      return data;
    },
    async getProviderSettledInfo(){
      await getPrintEnterPriseList({ name: this.inputMapParam }).then((res)=>{
        res.forEach((item) => {
          // 用户id
          findShopSettledInfo({enterPriseId: item.enterPriseId}).then((res) => {
            if (res.success) {
              if (res && res.data) {
                item.userUuid = res.data.userUuid;
              }
            }
          });
        });
        this.settledInfo = res;
		// console.log(res,111)
        this.initEcharts();
      });
    },
    getSolutionDetail(uuid) {
      //this.$router.push({ name: "solutionDetails", params: { uuid: uuid } });
      let routeData = this.$router.resolve({
        name: "solutionDetails",
        params: { uuid: uuid },
      });
      window.open(routeData.href, "_blank");
    },
    // 地图
    initEcharts() {
      var data1 = this.dealWithData();
		// console.log(data1,'data1')
      let settled = this.getSettledInfo();
      // console.log(settled)
	  // let arr = []
	  // settled.forEach((res)=>{
		 //  let mapStr = {}
		 //  mapStr.name = res.name1;
		 //  mapStr.value = res.value;
		 //  arr.push(mapStr)
	  // })
	  // console.log(arr)
      var echarts = this.$echarts.init(this.$refs.ChinaMap); //获取到容器的节点，初始化echarts实例
      var option = {
        tooltip: {
          // 设置鼠标移上去的弹框显示效果
          padding: 0,
          // backgroundColor: "transparent",
          formatter: (params) => {
            let htmlStr = ``;
            return htmlStr;
          },
        },
        legend: {
          orient: "vertical",
          top: "9%",
          left: "5%",
          icon: "circle",
          data: [],
          selectedMode: "single",
          selected: {},
          itemWidth: 12,
          itemHeight: 12,
          itemGap: 30,
          inactiveColor: "#b6d7ff",
          textStyle: {
            color: "#ec808d",
            fontSize: 14,
            fontWeight: 300,
            padding: [0, 0, 0, 15],
          },
        },
        //指定配置项和数据
        geo: {
          // 设置地图的显示信息
          map: "china", // 注意  哪个区域的就显示哪个区域的名称
          zoom: 2,
          label: {
            normal: {
              // 设置字体相关信息
              show: true,
              // color: "#000",
              textStyle: {
                color: "#909090",
                fontSize: 10,
                fontFamily: "Arial",
              },
            },
            emphasis: {
              // 设置鼠标移上去hover效果
              show: true,
              color: "#909090",
            },
          },
          roam: true,
          itemStyle: {
            normal: {
              areaColor: "#f8f8f8",
              borderColor: "#cecece",
              borderWidth: 1,
              // shadowColor: "#eef3f3",
              // shadowBlur: 15,
            },
            emphasis: {
              areaColor: "#cecece",
            },
          },
          // left: "5%",
          // right: "5%",
          // top: "5%",
          // bottom: "5%",
        },
        series: [
          //系列列表
          {
            type: "effectScatter", //系列类型 lines为路径图
            coordinateSystem: "geo", //系列坐标系 geo为地理坐标系
            geoIndex: 0,
            data: [],
          },
          {
            name: "Top 5",
            type: "effectScatter",
            coordinateSystem: "geo",
            data: settled,
            symbolSize: 15,
            tooltip: {
              show: false,
            },
            markArea: {
              label: {
                show: true,
              },
            },
            encode: {
              value: 2,
            },
            showEffectOn: "render",
            // 涟漪效果
            rippleEffect: {
              brushType: "stroke",
              color: "red",
              period: 9,
              scale: 5,
            },
            hoverAnimation: true,
            label: {
              formatter: "{b}",
              position: "right",
              show: true,
            },
            itemStyle: {
              color: "red",
              shadowBlur: 2,
              shadowColor: "#333",
            },
            zlevel: 1,
          },
        ],
      };
      echarts.setOption(option); // 使用刚指定的配置项和数据显示图表。
      /* data1.map((item)=>{
                    if(item.name1 === '苏州工业园区'){
                        this.mapPopY = 316 + "px";
                        this.mapPopX = 1193 + "px";
                        this.mapParkDetail.parkName = item.name1;
                        this.mapParkDetail.uuid = item.uuid;
                        this.mapParkDetail.imageURL = item.imageURL;
                        this.mapShow = true;
                    }
                })*/
      echarts.on("mousemove", (params) => {
        this.mapShow = false;
        this.mapPopY = params.event.offsetX + "px";
        this.mapPopX = params.event.offsetY + "px";
        if (params.componentType === "series") {
          this.mapParkDetail.parkName = params.data.name1;
          this.mapParkDetail.uuid = params.data.uuid;
          this.mapParkDetail.imageURL = params.data.imageURL;
          this.mapParkDetail.goodsCount = params.data.goodsCount;
          this.mapParkDetail.materialCount = params.data.materialCount;
          this.mapParkDetail.orderCount = params.data.orderCount;
          this.mapParkDetail.serviceCount = params.data.serviceCount;
          this.mapParkDetail.content = params.data.content;
          this.mapParkDetail.province = params.data.province;
          this.mapParkDetail.city = params.data.city;
          this.mapParkDetail.follow = params.data.follow;
          this.mapParkDetail.followUuid = params.data.followUuid;
          this.mapParkDetail.userUuid = params.data.userUuid;
          this.mapShow = true;
        }
      });
    },
    getNewsMore() {
      //this.$router.push("/news");
      let routeData = this.$router.resolve({
        name: "news",
      });
      window.open(routeData.href, "_blank");
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
/* 公用样式 */

/* 标题 */
.allTitle {
  text-align: center;
  margin-bottom: 40px;

  p {
    margin-bottom: 10px;
    font-size: 32px;
  }

  span {
    font-size: 14px;
    color: #505050;
  }

  .newBorderBox {
    justify-content: center;
    margin-top: 20px;

    i {
      background: #157efb;
      width: 50px;
      height: 5px;
    }
  }
}
  // 地图弹框样式
    .maps {
        position: absolute;
        z-index: 100;
        background: rgba(255, 255, 255, 0.797);
        padding: 20px;
        border-radius: 10px;
        max-width: 450px;

        .mapImg {
            width: 100px;
            border-radius: 50%;
            margin-right: 20px;
            flex-shrink: 0;

            /deep/ .el-image {
                margin-left: 25%;
                width: 50px;
                height: 50px;
                border-radius: 50%;
            }

            img {
                margin-left: 25%;
                width: 50px;
                height: 50px;
                border-radius: 50%;
                display: inline-block;
            }
            .mapImgIcon {
              margin-top: 10px;
              font-size: 14px;
              text-align: center;
              display: flex;
              align-items: center;
              i {
                color: #157efb;
                font-size: 18px;
                margin-right: 3px;
              }
              p {
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
            }
        }

        .mapMess {
          width: 70%;
            .mapMessT {
                cursor: pointer;
                font-size: 18px;
                font-weight: 500;
            }
            .mapMessText {
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              font-size: 14px;
            }
            .mapMessWork {
              font-size: 14px;
              margin: 8px 0;
              align-items: center;
              flex-wrap: wrap;
              .text {
                margin-right: 10px;
                margin-bottom: 5px;
              }
              p {
                margin-right: 10px;
                width: 28px;
              }
              span {
                color: #157efb;
                font-weight: bold;

              }
              .gangMess {
                display: inline-block;
                width: 2px;
                height: 14px;
                background: #666;
                // margin: 0 12px;
                margin-right: 5px;
              }
            }

            .mapMessBox {
                align-items: center;
                margin: 10px 0;

                .mapMessP {
                }

                i {
                    width: 2px;
                    height: 15px;
                    background: #cccccc;
                    margin: 0 10px;
                    display: inline-block;
                }
            }

            .mapMessBut {
                margin-top: 20px;
                display: flex;

                button {
                    border-radius: 3px;
                    color: #157efb;
                    padding: 6px 12px;
                    border: 1px solid #157efb;
                    background: #fff;
                    margin-right: 15px;
                    width: 130px;
                    cursor: pointer;
                }
                button:nth-child(2) {
                  border-radius: 3px;
                  color: #fff;
                  padding: 6px 12px;
                  border: 1px solid #157efb;
                  background: #157efb;
                }
            }
        }
    }
.gray {
  color: #929292;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
}

.blue {
  color: #157efb;
}

.home {
  cursor: default;
}

.topVideo {
  width: 100%;
  height: 100%;
  position: relative;

  img {
    height: 100%;
    width: 100%;
    display: block;
  }

  .topVideo_box {
    position: absolute;
    top: 30%;
    right: 15%;
    color: #fff;
    text-align: right;
    line-height: 45px;

    p {
      font-size: 24px;
    }

    button {
      background: #157efb;
      border-radius: 5px;
      color: #fff;
      border: none;
      padding: 7px 15px;
      margin-top: 30px;
    }
  }
}

/* 平台是核心 */
.content {
  padding: 100px 0 60px 0;
  background: url("../assets/3D/bottomTwo.png");
  text-align: center;
  height: 344px;
  background-size: 100% 100%;

  .content_top {
    width: 1200px;
    margin: 0 auto;
    justify-content: space-between;

    .content_top_box {
      width: 110px;
      height: 110px;
      background: #ebebeb;
      border-radius: 50%;
      border: 1px solid #d1d1d1;
      color: #bababa;
      position: relative;
    }

    .content_top_box1 {
      width: 120px;
      height: 120px;
      background: #c9e1f8;
      border-radius: 50%;
      border: 1px solid #157efb;
      color: #157efb;
      position: relative;
    }

    .contetn_flex {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);

      .content_box_name {
        font-size: 14px;
        margin-top: 7px;
      }
    }

    .content_box_img {
      height: 40px;

      img {
        height: 100%;
      }
    }
  }

  .content_title {
    margin: 24px 0;
  }

  .content_content {
    width: 476px;
    margin: 0 auto;
    font-size: 14px;
    color: #9c9c9c;
    line-height: 25px;
    margin-bottom: 60px;
  }

  .content_bottom {
    width: 90px;
    justify-content: space-between;
    margin: 0 auto;

    i {
      display: inline-block;
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background: #bababa;
    }

    .icon {
      background: #157efb;
    }
  }
}

// 平台核心的动画效果
@-webkit-keyframes fadeIn {
  0% {
    opacity: 0; /*初始状态 透明度为0*/
    transform: translateY(-50%);
  }
  50% {
    opacity: 0.5; /*中间状态 透明度为1*/
    transform: translateY(-25%);
  }
  100% {
    opacity: 1; /*结尾状态 透明度为0*/
    transform: translateY(0);
  }
}

.content_top1 {
  animation: fadeIn 1s linear 1;
  // animation: fadeIn 3s ease infinite 4s;
  overflow: hidden;
  transform: translateY(0);
  width: 1200px;
  margin: 0 auto;
}

/* 新闻中心 */
.new_center {
  margin: 60px 0 0;
  background: #fff;

  .new_center_more {
    margin: 0 auto;
    width: 1200px;
    text-align: right;
    font-size: 12px;
    // color: #606060;
    color: #1f7de9;
    margin-bottom: 10px;
    cursor: pointer;
  }

  .new_center_more:hover {
    color: #157efb;
  }

  .new_center_top {
    margin: 0 auto;
    width: 1200px;
    // justify-content: center;
    .new_center_top_left {
      cursor: pointer;

      width: 470px;
      margin-right: 30px;

      .new_left_img {
        width: 470px;
        flex-shrink: 0;
        // height: 300px;
        background: #efefef;

        img {
          height: 100%;
          width: 100%;
          display: block;
        }
      }

      .new_left_mess {
        color: #606060;
        font-weight: normal;
        background: #f0f7fd;
        padding: 13px 20px;

        .new_left_title {
          margin-bottom: 5px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }

        .new_left_time {
          font-size: 12px;
          color: #929292;
        }
      }
    }

    .new_center_top_left:hover {
      .new_left_title {
        color: #157efb;
      }
    }

    .new_center_top_right {
      .new_right_box {
        align-items: flex-start;
        cursor: pointer;

        background: #f0f7fd;

        .new_right_img {
          width: 300px;
          flex-shrink: 0;
          // height: 170px;
          background: #efefef;

          img {
            height: 100%;
            width: 100%;
            display: block;
          }
        }

        .new_right_content {
          padding: 0 18px;
          height: 100%;
          margin-top: 10px;

          .new_right_title {
            color: #606060;
            font-weight: normal;
            /*overflow: hidden;*/
            /*white-space: nowrap;*/
            /*text-overflow: ellipsis;*/
          }

          .new_right_time {
            font-size: 12px;
            color: #929292;
            display: inline-block;
            margin: 10px 0;
          }

          .new_right_text {
            // flex-wrap: wrap;
            display: -webkit-box;
            overflow: hidden;
            white-space: normal !important;
            text-overflow: ellipsis;
            word-wrap: break-word;
            -webkit-line-clamp: 3;
            -webkit-box-orient: vertical;
            font-size: 14px;
            color: #929292;
            font-weight: 300;
            line-height: 23px;
          }
        }
      }

      .new_right_box:hover {
        .new_right_title {
          color: #157efb;
        }
      }

      .new_right_box:nth-last-child(1) {
        // margin-top: 35px;
        margin-top: 9px;
      }
    }
  }

  .new_center_bottom {
    margin: 50px auto 0;
    width: 1200px;
    flex-wrap: wrap;
    justify-content: space-between;

    .new_bottom {
      cursor: pointer;
      padding-bottom: 25px;
      width: 270px;
      margin-bottom: 25px;

      span {
        font-size: 12px;
        margin-top: 15px;
      }

      p {
        display: -webkit-box;
        overflow: hidden;
        white-space: normal !important;
        text-overflow: ellipsis;
        word-wrap: break-word;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        font-size: 16px;
        line-height: 1.6;
        color: #808080;
        cursor: pointer;
        min-height: 50px;
      }
    }

    .new_bottom:hover {
      p {
        color: #157efb;
      }
    }

    .new_bottom_empty {
      margin: 0;
      width: 270px;
      height: 0px;
      visibility: hidden;
    }

    .new_bottom:nth-child(-n + 4) {
      border-bottom: 1px solid #ececec;
    }
  }
}

@keyframes new_center_fadeIn {
  0% {
    opacity: 0;
    transform: translateX(-50%);
  }

  100% {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes new_center_fadeIn_r {
  0% {
    opacity: 0;
    transform: translateX(50%);
  }

  100% {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes new_center_fadeIn_b {
  0% {
    opacity: 0;
    transform: translateY(50%);
  }

  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

.new_center_top_left {
  animation: new_center_fadeIn 1s linear 1;
}

.new_center_top_right {
  animation: new_center_fadeIn_r 1s linear 1;
}

.new_center_bottom {
  animation: new_center_fadeIn_b 1s linear 1;
}

/* 园区生态 */
.park {
  margin: 66px 0 0px;

  .park_box {
    // background: #efefef;
    // height: 600px;
    position: relative;

    .park_box_img {
      width: 100%;

      img {
        height: 600px;
        width: 100%;
        display: block;
      }
    }

    .messageAll {
      position: absolute;
      top: 42%;
      left: 42%;
      width: 510px;
      background: rgba(0, 0, 0, 0.194);
      padding: 15px;
      color: #fff;
      line-height: 27px;
    }

    .park_background {
      margin: 0 auto;
      width: 1390px;
      // padding-top: 38px;
      position: absolute;
      top: 10%;
      left: 0;
      bottom: 0;
      right: 0;

      .park_box_mess {
        box-shadow: 4px 5px 4px 0px #4a4a4a8f;
        width: 510px;
        height: 200px;
        padding: 30px;
        color: #fff;
        background-image: linear-gradient(
          153deg,
          rgba(47, 181, 253, 0.7) 5%,
          #157efb 100%
        );
        box-shadow: 8px 8px 0 0 rgba(0, 0, 0, 0.25);

        .park_box_messtitle {
          font-size: 24px;
          margin-bottom: 10px;
        }

        .park_box_messtext {
          margin-top: 20px;
          font-size: 16px;
          font-weight: 300;
          text-indent: 2em;
          line-height: 27px;
          height: 110px;
          display: -webkit-box;
          overflow: hidden;
          white-space: normal !important;
          text-overflow: ellipsis;
          word-wrap: break-word;
          -webkit-line-clamp: 4;
          -webkit-box-orient: vertical;
        }

        button {
          border: none;
          color: #157efb;
          background: #fff;
          height: 32px;
          width: 100px;
          border-radius: 4px;
          margin-top: 15px;
          font-size: 14px;
          cursor: pointer;
        }
      }

      .park_imglist {
        justify-content: space-between;
        align-items: center;
        margin-top: 120px;
        flex-wrap: wrap;

        .park_img2 {
          width: 190px;
          height: 0;
        }

        .park_img {
          // padding: 5px;
          width: 190px;
          height: 100px;
          // background: #ffffff3d;
          overflow: hidden;
          cursor: pointer;
          position: relative;

          img {
            height: 100%;
            width: 100%;
          }

          .parkFuimg {
            background: #262626aa;
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
          }
        }

        .park_active {
          padding: 3px;
          width: 200px;
          height: 110px;
          // background: #ffffff76;
          // box-shadow: 0px 0px 14px 2px #ffffffc9;
          overflow: hidden;

          img {
            height: 100%;
            width: 100%;
          }

          .parkFuimg {
            background: #ffffff00;
          }
        }
      }
    }
  }

  .park_bottom {
    background: #f0f7fd;

    .park_bottom_content {
      margin: 0 auto;
      width: 1200px;
      padding: 45px 0 60px;

      .park_bottom_title {
        font-size: 24px;

        i {
          display: inline-block;
          width: 50px;
          height: 5px;
          background: #157efb;
        }
      }

      .pack_flex {
        justify-content: space-between;
        flex-wrap: wrap;

        .park_bottom_list2 {
          width: 270px;
          height: 0;
        }

        .park_bottom_list {
          position: relative;
          margin-top: 40px;
          width: 270px;

          .enterpriseAll {
            position: absolute;
            bottom: 0;
            left: 0;
            width: 400px;
            font-size: 14px;
            background: rgba(0, 0, 0, 0.557);
            padding: 15px;
            color: #fff;
            z-index: 99;
          }

          .park_bottom_img {
            width: 270px;
            height: 150px;
            background: #fff;
            overflow: hidden;

            img {
              height: 100%;
              width: 100%;
              transition: all 1s;
            }
          }

          .park_bottom_text {
            cursor: pointer;
            background: #fff;
            padding: 15px 25px 30px;
            line-height: 20px;
            height: 124px;
            cursor: pointer;

            div {
              font-size: 14px;
              text-align: center;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
            }

            p {
              font-size: 13px;
              margin-top: 14px;
            }
          }
        }

        .park_bottom_list:hover {
          img {
            transform: scale(1.2);
          }

          .park_bottom_text {
            div {
              color: #157efb;
            }
          }
        }
      }
    }
  }
}

@keyframes park_fadeIn {
  0% {
    opacity: 0;
    transform: translateX(-50%);
  }

  100% {
    opacity: 1;
    transform: translateX(0);
  }
}

.park_box_mess {
  animation: park_fadeIn 1s linear 1;
}

@keyframes park2_fadeIn {
  0% {
    opacity: 0;
    transform: translateX(50%);
  }

  100% {
    opacity: 1;
    transform: translateX(0);
  }
}

.park_imglist {
  animation: park2_fadeIn 1s linear 1;
}

@keyframes parkBotton_fadeIn {
  0% {
    opacity: 0;
    transform: translateY(-20%);
  }

  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

.pack_flex {
  animation: parkBotton_fadeIn 1s linear 1;
}

/* 解决方案 */
.solution {
  margin-top: 66px;

  .solution_box {
    border-top: 1px solid #efefef;
    justify-content: space-between;

    .solution_boxmess {
      // width: 1200px;
      margin: 0 auto;
      flex-wrap: wrap;

      .solution_box_mess {
        height: 229px;
        cursor: pointer;
        border-top: 1px solid #efefef;
        box-sizing: border-box;
        -moz-box-sizing: border-box; /* Firefox */
        -webkit-box-sizing: border-box; /* Safari */
        border-right: 1px solid #efefef;
        // background: hsla(0,0%,100%,0);
        // background: url("../assets/solutionHome.png") no-repeat right center;
        background: hsla(0, 0%, 100%, 0);
        background-size: 150% 229px;
        overflow: hidden;
        width: 50%;
        padding: 34px 0 42px 0;
        justify-content: flex-end;

        .solution_box_text {
          width: 600px;

          h5 {
            font-size: 16px;
            font-weight: normal;
            color: #157efb;
            margin-bottom: 10px;
          }

          h4 {
            margin: 0 0 15px 0;
            font-size: 18px;
            font-weight: normal;
            width: 470px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }

          p {
            font-size: 14px;
            width: 470px;
          }
        }
      }

      .solution_box_mess:hover {
        background: no-repeat center center;
        background-size: 120% 229px;
        -webkit-transition: background-size 0.3s linear;
        transition: background-size 0.3s linear;
      }

      .solution_box_mess:nth-child(2n + 2) {
        border-right: none;
        justify-content: flex-start;
        padding-left: 32px;
        width: 50%;
      }
    }
  }

  .solution_box:nth-last-child(1) {
    border-bottom: 1px solid #efefef;
  }
}

@keyframes solu_fadeIn {
  0% {
    opacity: 0;
    transform: translateY(50%);
  }

  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

.solution_box {
  animation: solu_fadeIn 1s linear 1;
}

/* 主要业务 */
.main {
  margin-top: 60px;

  .main_tabs {
    align-items: center;
    justify-content: center;
    font-size: 16px;
    width: 970px;
    margin: 0 auto 10px auto;

    p {
      width: 170px;
      padding-bottom: 15px;
      text-align: center;
      cursor: pointer;
      border-bottom: 4px solid #fff;
    }

    .main_active {
      border-bottom: 4px solid #157efb;
      color: #157efb;
    }
  }

  .main_mess {
    // align-items: center;
    .main_mess_img {
      text-align: center;
      width: 50%;

      img {
        width: 100%;
        height: 100%;
        display: block;
      }
    }

    .main_mess_content {
      // background: linear-gradient(-45deg, #219afd, #2eb6fd);
      // background: #2eb6fd;
      width: 50%;
      color: #fff;
      font-weight: 300;
      position: relative;

      .main_mess_content2 {
        width: 100%;

        img {
          width: 100%;
          display: block;
        }
      }

      .main_mess_box {
        position: absolute;
        top: 50%;
        transform: translate(0, -50%);
        left: 85px;
        width: 500px;

        .main_con_title {
          font-size: 26px;
        }

        .main_con_text {
          font-size: 18px;
          margin: 30px 0 50px;
        }

        .main_con_more {
          font-size: 14px;
          cursor: pointer;
        }
      }
    }
  }
}

.mapPosition {
  position: relative;
  background: #9fd7fc;

  .mapInput {
    position: absolute;
    z-index: 100;
    top: 10%;
    left: 12%;
    height: 33px;
    // align-items: center;
    /deep/ .el-input {
      height: 33px;
      width: 221px;
    }

    /deep/ .el-input__inner {
      height: 33px;
      border-radius: 0;
    }
	/deep/ .el-input__suffix{
		top: -3px;
	}

    input {
      width: 221px;
      height: 100%;
      background: #fff;
      border: none;
      padding: 0px 14px;
    }

    i {
      display: inline-block;
      height: 100%;
      width: 40px;
      line-height: 33px;
      text-align: center;
      background: #157efb;
      color: #fff;
      font-size: 18px;
    }
  }
}

@keyframes new_fadeIn {
  0% {
    opacity: 0;
    transform: translateX(-50%);
  }

  100% {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes new_fadeIn_r {
  0% {
    opacity: 0;
    transform: translateX(50%);
  }

  100% {
    opacity: 1;
    transform: translateX(0);
  }
}

.main_mess_img {
  animation: new_fadeIn 1s linear 1;
}

.main_mess_content {
  animation: new_fadeIn_r 1s linear 1;
}

// 地图弹框样式
.map {
  align-items: center;
  position: absolute;
  z-index: 100;
  background: rgba(255, 255, 255, 0.797);
  padding: 20px;
  border-radius: 10px;
  width: 400px;

  .mapImg {
    flex-shrink: 0;
    width: 90px;
    height: 90px;
    background: #efefef;
    border-radius: 50%;
    margin-right: 10px;

    /deep/ .el-image {
      width: 100%;
      height: 100%;
      border-radius: 50%;
    }

    img {
      // border-radius: 50%;
      display: inline-block;
    }
  }

  .mapMess {
    .mapMessT {
      font-size: 18px;
      font-weight: 500;
    }

    .mapMessBox {
      align-items: center;
      margin: 10px 0;

      .mapMessP {
      }

      i {
        width: 2px;
        height: 15px;
        background: #cccccc;
        margin: 0 10px;
        display: inline-block;
      }
    }

    .mapMessBut {
      margin-top: 20px;
      cursor: pointer;
      display: flex;
      align-items: center;
      button {
        border-radius: 3px;
        color: #157efb;
        padding: 6px 12px;
        border: 1px solid #157efb;
        background: #fff;
        margin-right: 15px;
        width: 150px;
      }

      // button:nth-child(2) {
      //   border-radius: 3px;
      //   color: #fff;
      //   padding: 6px 12px;
      //   border: 1px solid #157efb;
      //   background: #157efb;
      // }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/index.vue